import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AuthUser } from "@/core/api/types/auth";

interface ProfileStore {
  profile: AuthUser | null;
  setProfile: (profile: AuthUser | null) => void;
}

export const useProfileStore = create<ProfileStore>()(
  persist(
    (set) => ({
      profile: null,
      setProfile: (profile) => set({ profile }),
    }),
    {
      name: "profile-storage",
    }
  )
);
